<script setup lang="ts">
import { NSkeleton } from 'naive-ui'
import { useAttrs } from 'vue'

const props = withDefaults(defineProps<{
  animated?: boolean
  round?: boolean
  size?: 'small' | 'medium' | 'large'
  width?: string | number
  height?: string | number
  text?: boolean
  circle?: boolean
  sharp?: boolean
  lines?: number | number[]
  lineHeight?: string | number
  lineWidth?: string | number | string[] | number[]
  repeat?: number
  loading?: boolean
}>(), {
  animated: true,
  round: false,
  size: 'medium',
  width: undefined,
  height: undefined,
  text: false,
  circle: false,
  sharp: false,
  lines: 1,
  lineHeight: undefined,
  lineWidth: undefined,
  repeat: 1,
  loading: true,
})

const attrs = useAttrs()
</script>

<template>
  <NSkeleton
    :animated="animated"
    :round="round"
    :size="size"
    :width="width"
    :height="height"
    :text="text"
    :circle="circle"
    :sharp="sharp"
    :lines="lines"
    :line-height="lineHeight"
    :line-width="lineWidth"
    :repeat="repeat"
    :loading="loading"
    v-bind="attrs"
  >
    <template #default>
      <slot />
    </template>
  </NSkeleton>
</template>

<style scoped>
/* Custom styles can be added here if needed */
</style>
